import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//"homepage": "/software/public",

const basename = "/software"; // Adjust this if your app is inside another folder
//const basename = "/";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router basename={basename}> {/* ✅ Fix wrong routing */}
    <App />
  </Router>
);

reportWebVitals();

